// import React from "react";
// import { useTranslation } from "react-i18next";
// const ViewStore = ({ data }) => {
//   const { t } = useTranslation();
//   const styles = {
//     container: {
//       margin: "auto",
//       width: "80%",
//       padding: "20px",
//       background: "white",
//       borderRadius: "8px",
//       boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
//     },
//     title: {
//       textAlign: "center",
//       marginBottom: "20px",
//     },
//     table: {
//       width: "100%",
//     },
//     label: {
//       paddingRight: "10px",
//       verticalAlign: "top",
//       padding: "1rem",
//     },
//   };
//   console.log("data ==>", data);
//   return (
//     <>
//       <div style={styles.container}>
//         {/* <h2 style={styles.title}>{data?.store_name}</h2> */}
//         <table style={styles.table}>
//           <tbody>
//             <tr style={{ borderBottom: "1px dotted black" }}>
//               <td>{t("Title")}</td>
//               <td>{t("Details")}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Store Owner Name")}:</td>
//               <td>
//                 {data?.store_owner_info?.[0]?.first_name +
//                   data?.store_owner_info?.[0]?.last_name}
//               </td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Store Owner Email")}:</td>
//               <td>
//                 <td>{data?.store_owner_info?.[0]?.email}</td>
//               </td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Store Owner Phone Number")}:</td>
//               <td>{data?.store_owner_info?.[0]?.phone_no}</td>
//             </tr>

//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Store Name")}:</td>
//               <td>{data?.store_name}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Store Phone No")}:</td>
//               <td>{data?.phone_no}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Store Password")}:</td>
//               <td>{data?.password}</td>
//             </tr>

//             <tr>
//               <td style={styles.label}>{t("Store Email")}:</td>
//               <td>{data?.email}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Store Description")}:</td>
//               <td>{data?.description}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Store User")}:</td>
//               <td>{data?.role}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Store Location")}:</td>
//               <td>{data?.location?.address}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </>
//   );

// };

// export default ViewStore;
import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons

const ViewStore = () => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  function truncateText(text, maxLength) {
    if (text && text?.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  return (
    <div className="flex gap-8">
      <div style={styles.container} className="min-h-[37rem]">
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>{t("Back")}</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-semibold">
              {t("View Store")}
            </p>
            <hr className="mb-4" />
            {/* Store Owner Information */}
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td className="font-lighht w-[12rem] text-[14px] font-bold" style={styles.label}>
                  {t("Store Owner Name")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px]">{data?.store_owner_info?.[0]?.first_name + "" + data?.store_owner_info?.[0]?.last_name}</td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>
                  {t("Store Owner Email")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.store_owner_info?.[0]?.email}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>
                  {t("Store Owner Phone No")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.store_owner_info?.[0]?.phone_no}
                </td>
              </tr>
            </div>
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>
                  {t("Store Name")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px]">
                  {data?.store_name}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Store Phone No")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.phone_no}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>
                  {t("Store Location")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  <p>
                    {data?.address}
                  </p>
                </td>
              </tr>
              {/* <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>{t("Store Password")}                </td>
                <td className="flex w-[12rem] justify-between pl-4 text-[14px] ">
                  <p title={data?.unhashed_password}>
                    {showPassword
                      ? truncateText(data?.unhashed_password, 15)
                      : truncateText("*".repeat(data?.unhashed_password?.length), 15)}
                  </p>
                  <button
                    type="button"
                    onClick={() => setShowPassword((prevState) => !prevState)}
                    // className="absolute bottom-[-20px] right-4 top-3"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                  </button>
                </td>
              </tr> */}
            </div>

            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Store Email")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.email}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Store Description")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.description}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Store User")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.role}
                </td>
              </tr>
            </div>
            {/* <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}>
                  {t("Store Location")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  <p>
                    {data?.address}
                  </p>
                </td>
              </tr>
              <tr className="flex flex-col">
                <td 
                  className="font-lighht w-[12rem] text-[14px]"
                  style={styles.label}
                ></td>
                <td className="w-[12rem] pl-4 text-[14px] font-semibold"></td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px]"
                  style={styles.label}
                ></td>
                <td className="w-[12rem] pl-4 text-[14px] font-semibold"></td>
              </tr>
            </div> */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewStore;
